import { makeAutoObservable } from 'mobx';
import { inject, injectable } from 'inversify';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';

@injectable()
export class OsiActsPageViewModel {
  constructor(@inject(OsiServiceIdentifier) private osiModule: OsiService) {
    makeAutoObservable(this);
  }

  get pageTitle(): string | undefined {
    return this.osiModule?.osiInfo?.name || 'Кабинет ОСИ';
  }
}
